import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Cookie from 'utils/cookies';
import { tpShowModalEmitter } from 'modules/WithTimesPointModal/TimesPointModalUtils';
import { getAllActivities } from 'modules/WithTimesPointModal/redux';
import { LOGIN_MAPPED_ON_LIVE } from 'constants/index';
import { loadLoginTimesPoints, setInititializeTPFlag } from './redux';
// import Cookie from '../../utils/cookies';
import {
  getEmail,
  getSsoid,
  postLoginActions,
  fireActivity,
  resetDailyCheckInEntries,
  getTicketid,
} from './TimesPointUtils';

const REINIT_TP_WIDGET_EVENT_NAME = 'reinit_tp_widget';

export function reinitializeTPWidgets(obj) {
  const initEvent = new Event(REINIT_TP_WIDGET_EVENT_NAME);
  if (typeof obj === 'object' && obj.divId && obj.widgetType) {
    initEvent.customObj = obj;
  }
  window.dispatchEvent(initEvent);
}

class WithTimesPoint extends React.Component {
  static propTypes = {
    userData: PropTypes.shape({ isLoggined: PropTypes.bool }),
    getLoginTimesPointData: PropTypes.func.isRequired,
    setInititializeTPFlag: PropTypes.func.isRequired,
    userPointsData: PropTypes.shape({
      link: PropTypes.string,
      description: PropTypes.string,
      points: PropTypes.number,
    }),
    isWapView: PropTypes.bool.isRequired,
    getAllActivities: PropTypes.func.isRequired,
    loadTimePointSdk: PropTypes.bool,
    isMobile: PropTypes.bool,
  };
  static defaultProps = {
    userData: undefined,
    userPointsData: undefined,
    loadTimePointSdk: false,
    isMobile: false,
  };
  constructor(props) {
    super(props);
    this.state = {};
    this.sdkLoaded = false;
    this.isLoggedIn = false;
  }
  componentDidMount() {
    if (
      window.TimesGDPR &&
      window.TimesGDPR.common.consentModule.gdprCallback
    ) {
      window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
        if (!dataObj.isEUuser) {
          if (
            this.props.isWapView &&
            this.props.userData &&
            // eslint-disable-next-line react/prop-types
            typeof this.props.userData.isLoggedIn === 'boolean'
          ) {
            this.getUserengagementMetrics(this.props.userData.isLoggedIn);
          }

          if (!this.props.isWapView || this.props.loadTimePointSdk) {
            // this.loadSDK();
          } else {
            this.setState({ sdkLoaded: true });
          }
          // this.setConfigObj();
          document.body.addEventListener('tpwidget-ready', () => {
            window.loaded = 'tploaded';
            if (!this.props.disableTimesPointWidget) {
              this.initialiseTimesPoint();
              window.addEventListener(
                REINIT_TP_WIDGET_EVENT_NAME,
                this.reinitTPWidget.bind(this),
              );
            }
          });

          this.props.getAllActivities(this.props.isMobile);
          fireActivity(
            this.props.isMobile,
            'dailycheckin',
            Math.round(new Date().getTime()),
          );
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.sdkLoaded &&
      ((!(prevProps.userData && prevProps.userData.isLoggedIn) &&
        this.props.userData &&
        // eslint-disable-next-line react/prop-types
        this.props.userData.isLoggedIn) ||
        (this.props.userData.isLoggedIn && !this.isLoggedIn))
    ) {
      // this.props.getLoginTimesPointData(getSsoid());
      // this.initialiseTimesPoint();
      postLoginActions();
      this.isLoggedIn = true;
      fireActivity(
        this.props.isMobile,
        'visit',
        Math.round(new Date().getTime()),
      );
      fireActivity(
        this.props.isMobile,
        'register',
        Math.round(new Date().getTime()),
      );
    }
    if (
      this.state.sdkLoaded &&
      prevProps.userData &&
      prevProps.userData.isLoggedIn &&
      this.props.userData.isLoggedIn === false
    ) {
      if (window.TPWidget) window.TPWidget.logoutAction();
      this.isLoggedIn = false;
    }

    // Reset daily checkin if user is logged in
    if (
      this.state.sdkLoaded &&
      prevProps.userData &&
      prevProps.userData.isLoggedIn === false &&
      this.props.userData &&
      this.props.userData.isLoggedIn === true
    ) {
      resetDailyCheckInEntries(this.props.isMobile);
      if (
        typeof window !== 'undefined' &&
        window.TimesGDPR &&
        window.TimesGDPR.common.consentModule.gdprCallback
      ) {
        window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
          if (!dataObj.isEUuser) {
            fireActivity(
              this.props.isMobile,
              'dailycheckin',
              Math.round(new Date().getTime()),
            );
          }
        });
      }
    }

    if (
      this.props.isWapView &&
      this.props.userData &&
      // eslint-disable-next-line react/prop-types
      typeof this.props.userData.isLoggedIn === 'boolean' &&
      (prevProps.userData &&
        prevProps.userData.isLoggedIn !== this.props.userData.isLoggedIn)
    ) {
      this.getUserengagementMetrics(this.props.userData.isLoggedIn);
    }

    // fireActivity('dailycheckin', Math.round(new Date().getTime()));
  }

  getUserengagementMetrics = isLoggedIn => {
    if (typeof window === 'object' && window.tpsdk) {
      const ticketId = Cookie.get('TicketId') || '';
      const params = {
        platform: this.props.isWapView ? 'msite' : 'web',
        channelCode: 'TOI',
      };

      if (isLoggedIn) {
        params.ticketId = ticketId;
      }

      window.tpsdk('init', params);
      window.tpsdk(
        'fetch',
        'nextEngagement',
        '',
        this.props.getLoginTimesPointData,
      );
    }
  };

  reinitTPWidget(event) {
    this.initialiseTimesPoint(event.customObj || '');
  }

  setConfigObj() {
    this.TPconfig = {
      widgettypes: [
        { divId: 'widget-head', widgetType: 'tpwidget-one' },
        { divId: 'widget-tp-sticky', widgetType: 'tpwidget-two' },
        { divId: 'widget-two-ATF', widgetType: 'tpwidget-two' },
        { divId: 'widget-two-BTF', widgetType: 'tpwidget-two' },
        { divId: 'widget-two', widgetType: 'tpwidget-two' },
        { divId: 'widget-two-vs', widgetType: 'tpwidget-two' },
        {
          divId: 'widget-banner',
          widgetType: 'tpwidget-banner',
          viewportId: 'TOI',
          carousel: true,
          platform: this.props.isWapView ? 'msite' : 'web',
        },
        {
          divId: 'tpwidget-offer-full',
          widgetType: 'tpwidget-offer-full',
          platform: this.props.isWapView ? 'msite' : 'web',
        },
      ],
      widgetsArray: [],
      isUserLoggedIn: false,
      isInitialised: false,
      userInfo: [],
      email: getEmail(),
      url: escape(document.location.href),
      pcode: 'TOI',
      scode: 'News',
      oid: '',
      uid: getSsoid(),
      aname: '',
      txnId: '',
      firsttime: true,
    };
  }

  loadSDK() {
    this.sdkLoaded = true;
    const that = this;
    window.tp_js = (function attachScript(d, myElement, id) {
      const fjs = d.getElementsByTagName(myElement)[0];
      const t = window.tp_js || {};
      if (d.getElementById(id)) return t;
      const js = d.createElement(myElement);
      js.id = id;
      js.src = `https://${
        !(LOGIN_MAPPED_ON_LIVE || __PROD__)
          ? 'test-img.timespoints.com'
          : 'image.timespoints.iimg.in'
      }/static/tpwidgetV2/static/dist/js/main.js`;
      js.onload = function() {
        that.setState({ sdkLoaded: true });
      };
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function ready(f) {
        t._e.push(f);
      };

      return t;
    })(document, 'script', 'tp-wjs');
  }

  initialiseTimesPoint(obj) {
    this.a = '';
    const widgettypes = (typeof obj === 'object'
      ? [obj]
      : this.TPconfig.widgettypes
    ).map(
      item =>
        item.divId === 'widget-banner'
          ? {
              ele: item.divId,
              widgetType: item.widgetType,
              viewportId: item.viewportId,
              platform: item.platform,
              carousel: item.carousel,
              channel: 'TOI',
            }
          : {
              ele: item.divId,
              widgetType: item.widgetType,
              channel: 'TOI',
              platform: this.props.isWapView ? 'msite' : 'web',
              callback() {
                tpShowModalEmitter(item.divId);
              },
            },
    );
    if (
      typeof window.TPWidget !== 'undefined' &&
      typeof window.TPWidget.init === 'function'
    ) {
      if (getTicketid()) {
        this.TPconfig.email = getEmail();
        this.TPconfig.uid = getSsoid();
        this.ticketId = getTicketid();
        window.TPWidget.init({
          widgets: widgettypes,
          userLoginInfo: {
            ticketId: this.ticketId,
          },
        });
      } else {
        window.TPWidget.init({
          widgets: widgettypes,
        });
      }

      this.props.setInititializeTPFlag();
    }
  }
  render() {
    const { userPointsData, isMobile } = this.props;
    if (userPointsData) {
      if (isMobile) {
        return <div />;
      }
      return null;
    }
    return null;
  }
}

const mapStateToProps = state => ({
  userPointsData: state?.timesPoint?.userData,
  userData: _get(state, 'login.userData', {}),
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  getLoginTimesPointData: params => {
    dispatch(loadLoginTimesPoints(params));
  },
  setInititializeTPFlag: () => {
    dispatch(setInititializeTPFlag());
  },
  getAllActivities: isWapView => {
    dispatch(getAllActivities(isWapView));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WithTimesPoint);
